export default __webpack_public_path__ + "static/media/welfare-calendar.ba750243.svg";